import PendingShipmentsList from './pending-shipments-list';
export { PendingShipmentsList };
